import ShowEditPrompt from './ShowEditPrompt';

export default ShowEditPrompt;
